import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import React from "react";
import { useBillCycleMeterDashboard } from "../../hooks";
import { MeterTypesCard } from "../../progressCard";
interface DashboardTabProps {
  billCycleId: number; // or string, depending on your use case
}

export const DashboardTab: React.FC<DashboardTabProps> = ({ billCycleId }) => {
  const { data: billCycleMeterDashboard } =
    useBillCycleMeterDashboard(billCycleId);
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="transition-all duration-300 hover:shadow-xl hover:scale-102 focus-within:shadow-2xl focus-within:ring-2 focus-within:ring-accent">
          <CardHeader>
            <CardTitle>Reading Collection Status</CardTitle>
            <CardDescription>Collection progress comparison</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <div>
                <div className="flex justify-between mb-2">
                  <span className="text-sm">Current Cycle</span>
                  <span className="text-sm font-medium">
                    {billCycleMeterDashboard?.currentCycleReadingPercentage ??
                      0}
                    %
                  </span>
                </div>
                <Progress
                  value={
                    billCycleMeterDashboard?.currentCycleReadingPercentage ?? 0
                  }
                  className="h-2"
                />
              </div>

              <div>
                <div className="flex justify-between mb-2">
                  <span className="text-sm">Previous Cycle</span>
                  <span className="text-sm font-medium">
                    {/* This should be previous cycle billCycleMeterDashboard */}
                    {billCycleMeterDashboard?.previousCycleReadingPercentage ??
                      0}
                    %
                  </span>
                </div>
                <Progress
                  value={
                    billCycleMeterDashboard?.previousCycleReadingPercentage ?? 0
                  }
                  className="h-2"
                />
              </div>

              <div className="text-xs text-muted-foreground">
                {billCycleMeterDashboard?.readingComparisonPercentage >= 0
                  ? "Increased"
                  : "Decreased"}{" "}
                by{" "}
                {Math.abs(
                  billCycleMeterDashboard?.readingComparisonPercentage || 0
                )}
                % compared to previous cycle
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="transition-all duration-300 hover:shadow-xl hover:scale-102 focus-within:shadow-2xl focus-within:ring-2 focus-within:ring-accent">
          <CardHeader>
            <CardTitle>Reading Validation Status</CardTitle>
            <CardDescription>Validation progress comparison</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <div>
                <div className="flex justify-between mb-2">
                  <span className="text-sm">Current Cycle</span>
                  <span className="text-sm font-medium">
                    {" "}
                    {billCycleMeterDashboard?.currentValidationPercentage || 0}%
                  </span>
                </div>
                <Progress
                  value={
                    billCycleMeterDashboard?.currentValidationPercentage || 0
                  }
                  className="h-2"
                />
              </div>

              <div>
                <div className="flex justify-between mb-2">
                  <span className="text-sm">Previous Cycle</span>
                  <span className="text-sm font-medium">
                    {billCycleMeterDashboard?.previousValidationPercentage || 0}
                    %
                  </span>
                </div>
                <Progress
                  value={
                    billCycleMeterDashboard?.previousValidationPercentage || 0
                  }
                  className="h-2"
                />
              </div>

              <div className="text-xs text-muted-foreground">
                {billCycleMeterDashboard?.validationComparisonPercentage >= 0
                  ? "Increased"
                  : "Decreased"}{" "}
                by{" "}
                {Math.abs(
                  billCycleMeterDashboard?.validationComparisonPercentage || 0
                )}
                % compared to previous cycle
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <MeterTypesCard
          meterTypePercentages={billCycleMeterDashboard?.meterTypePercentages}
          title="Meter Types Breakdown"
          description="Distribution by meter type"
        />

        <MeterTypesCard
          meterTypePercentages={
            billCycleMeterDashboard?.readingStatusPercentages
          }
          title="Reading Types Distribution"
          description="Normal vs RCNT vs Faulty"
        />
      </div>
    </div>
  );
};
